// en, de, fr, pt
export default {
	en: {
		Users:'Users',
		Selected:'Selected',
		EmailList:'Email',
		Event:'Event',
		StopRadius:'Stop radius (Meters)',
		StopPeriod:'Stop period',
		Enter:'Enter',
		Exit:'Exit',
		Cross:'Cross',
		Idle:'Idle',

		NameZone:'Name zone',
		DetectionRule:"Detection Rule",
		Polygon:'Polygon',
		Circle:'Circle',
		Polyline:'Polyline',
		Save:'Save',
		Delete:'Delete',
		Add:'Add',
		RealtimeMonitoring:'RealtimeMonitoring',
		BaseStation:'Base station',
		Vessel:'Vessel',
		EventNotification:'Event Nitification',
		VesselReport:'Vessel Report',
		VesselGroup:'Vessel Group',
		Zone:'Zone',
		Setting:'Setting',
		ShipType:'Ship Type',
		NavigationStatus:'Navigation Status',
		PositionFixType:'Position Fix Type',
		MID:'MID',
		Dashboard: 'Dashboard',
		eCommerce: 'eCommerce',
		Apps: 'Apps',
		Todo: 'Todo',
		Chat: 'Chat',
		Email: 'Email',
		Calendar: 'Calendar',
		Shop: 'Shop',
		Cart: 'Cart',
    	WishList: 'Wish List',
		Checkout: 'Checkout',
		UIElements: 'UI Elements',
		DataList: 'Data List',
		ListView: 'List View',
		ThumbView: 'Thumb View',
		Grid: 'Grid',
		Vuesax: 'Vuesax',
		Tailwind: 'Tailwind',
		Colors: 'Colors',
		Card: 'Card',
		Basic: 'Basic',
		Statistics: 'Statistics',
		Analytics: 'Analytics',
		CardActions: 'Card Actions',
		Table: 'Table',
		Components: 'Components',
		Alert: 'Alert',
		Avatar: 'Avatar',
		Badge: 'Badge',
		Breadcrumb: 'Breadcrumb',
		Button: 'Button',
		Chip: 'Chip',
		Collapse: 'Collapse',
		Dialogs: 'Dialogs',
		Divider: 'Divider',
		DropDown: 'DropDown',
		List: 'List',
		Loading: 'Loading',
		Navbar: 'Navbar',
		Notifications: 'Notifications',
		Pagination: 'Pagination',
		Popup: 'Popup',
		Progress: 'Progress',
		Sidebar: 'Sidebar',
		Slider: 'Slider',
		Tabs: 'Tabs',
		Tooltip: 'Tooltip',
		Upload: 'Upload',
		Forms: 'Forms',
		FormElements: 'Form Elements',
		Select: 'Select',
		Switch: 'Switch',
		Checkbox: 'Checkbox',
		Radio: 'Radio',
		Input: 'Input',
		NumberInput: 'Number Input',
		Textarea: 'Textarea',
		FormLayouts: 'Form Layouts',
		FormWizard: 'Form Wizard',
		FormValidation: 'Form Validation',
		Pages: 'Pages',
		Authentication: 'Authentication',
		Login: 'Login',
		Register: 'Register',
		ForgotPassword: 'Forgot Password',
		ResetPassword: 'Reset Password',
		LockScreen: 'Lock Screen',
		ComingSoon: 'Coming Soon',
		Error: 'Error',
		404: '404',
		500: '500',
		NotAuthorized: 'Not Authorized',
		Maintenance: 'Maintenance',
		Profile: 'Profile',
		Invoice: 'Invoice',
		FAQ: 'FAQ',
		Search: 'Search',
		KnowledgeBase: 'Knowledge Base',
		ChartsAndMaps: 'Charts & Maps',
		Charts: 'Charts',
		ApexCharts: 'Apex Charts',
		chartjs: 'chartjs',
		echarts: 'echarts',
		chartist: 'chartist',
		GoogleMap: 'Google Map',
		Extensions: 'Extensions',
		QuillEditor: 'Quill Editor',
		DragAndDrop: 'Drag & Drop',
		Datepicker: 'Datepicker',
		AccessControl: 'Access Control',
		EditorView: 'Editor View',
		AdminView: 'Admin View',
		I18n: 'I18n',
		Carousel: 'Carousel',
		Clipboard: 'Clipboard',
		ContextMenu: 'Context Menu',
		Others: 'Others',
		MenuLevels: 'Menu Levels',
		MenuLevel2p1: 'Menu Level 2.1',
		MenuLevel2p2: 'Menu Level 2.2',
		MenuLevel3p1: 'Menu Level 3.1',
		MenuLevel3p2: 'Menu Level 3.2',
		DisabledMenu: 'Disabled Menu',
		Support: 'Support',
		Documentation: 'Documentation',
		RaiseSupport: 'Raise Support',
		demoTitle: 'Card Title',
		demoText: 'Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.',

		FunctionUnavailableNow: 'This function is unavailable for now',
		PleaseSelectInList: 'Please item in list',
		EmailIsAlreadyUsed: 'Email address is already in use.',
		RegisterDonePleaseVerifyEmail: 'Create an account successfully, please verify your email address first.',
		PasswordResetUrlSent: 'Password reset url has been sent to your email address.',
		Home: 'Home',

		Topics: 'Topics',
		Scoreboard: 'Scoreboard',
		
		Lesson1: 'Lesson 1',
		Lesson1Unit1: 'Excise Items',
		Lesson1Unit2: 'Fee Rates',
		Lesson1Unit3: 'Documents and Forms',
		Lesson2: 'Lesson 2',
		Lesson2Unit1: 'Divisions',
		Lesson2Unit2: 'Positions',
		Lesson3: 'Lesson 3',
		Lesson3Unit1: 'Organizational Vocab..',
		Lesson4: 'Lesson 4',
		Lesson5: 'Lesson 5',
		Lesson6: 'Lesson 6',
		Lesson6Unit1: '6.1 Unit 1',
		Lesson6Unit1Chapter1: 'Chapter 1',
		Lesson6Unit1Chapter2: 'Chapter 2',
		Lesson6Unit1Quiz: 'Quiz',
		Lesson7: 'Lesson 7',
		Lesson7Unit1: 'Tax Collection',
		Lesson7Unit1Chapter1: 'ExciseTaxRegistration',
		Lesson7Unit1Chapter2: 'Apply for a License',
		Lesson7Unit1Chapter3: 'Tax Payment',
		Lesson7Unit1Chapter4: 'Field Audit',
		Lesson7Unit2: 'Suppression',
		Lesson7Unit2Chapter1: 'Onsite Inspection',
		Lesson7Unit2Chapter2: 'BorderCheckpoint..',
		Lesson7Unit3: 'ExciseTaxCalculation',
		Lesson7Unit4: 'Language Focus',
		Lesson8: 'Lesson 8',
		Lesson8Unit1: 'Grammar',
		Lesson8Unit2: 'Vocabulary',
		Lesson8Unit3: 'Reading Comprehension',
		Lesson8Unit4: 'Conversations and Dialogues',
		Lesson8Unit5: 'Practice',
		Lesson8Unit6: 'Test',
		Lesson9: 'Lesson 9'

	},
	th: {
		
		excise: {
			
			LearningTopic: 'หัวข้อแบบเรียน',
			AboutExcise: 'ข้อมูลเกี่ยวกับกรมสรรพสามิต',
			LISTOFDOCUMENTSANDFORMS:  'รายชื่อเอกสารและฟอร์มที่ใช้ในการปฏิบัติงาน',
			GoodsAndServices: 'รายชื่อสินค้า กิจการ และบริการที่ระบุไว้ในบัญชีพิกัดอัตราภาษีสรรพสามิต',
			OilAndPetroleumProducts: 'สินค้าน้ำมันและผลิตภัณฑ์น้ำมัน',
			Beverages: 'สินค้าเครื่องดื่ม',
			ElectronicAppliances: 'สินค้าเครื่องไฟฟ้า',
			Battery: 'แบตเตอรี่',
			GlassAndGlassware: 'สินค้าแก้วและเครื่องแก้ว',
			Automobiles: 'สินค้ารถยนต์',
			Motorcycle: 'รถจักรยานยนต์',
			Boats: 'สินค้าเรือ',
			PerfumeryAndCosmetics: 'สินค้าผลิตภัณฑ์เครื่องหอมและเครื่องสำอาง',
			CarpetsAndOtherFloorCoveringTextiles: 'สินค้าพรมและสิ่งทอปูพื้นอื่นๆ',
			MarbleAndGraniteProducts: 'สินค้าหินอ่อนและหินแกรนิต',
			
			AboutExcise: '',
			DivisionAndPosition: '',
			Vocabulary: '',
			Pronunciation: '',
			GeneralEnglish1: '',
			GeneralEnglish2: '',
			EnglishAtWork: '',
			KhoPhorRecap: '',
			UsefulLink: '',
		},
		Users:'ผู้ใช้งาน',
		Selected:'เลือกโซน',	
		EmailList:'รายชื่ออีเมลล์',
		Event:'เหตุการณ์',
		StopRadius:'รัศมีหยุเนิ่ง (เมตร)',
		StopPeriod:'เวลาหยุดนิ่ง',
		Enter:'เข้า',
		Exit:'ออก',
		Cross:'ผ่าน',
		Idle:'อยู่กับที่',
		NameZone:'ชื่อโซน',	
		DetectionRule:"กฏการเเจ้งเตือน",
		Polygon:'โซนหลายเหลี่ยม',
		Circle:'โซนวงกลม',
		Polyline:'โซนเส้น',
		Save:'บันทึก',
		Delete:'ลบ',
		Add:'เพิ่ม',
		RealtimeMonitoring:'ติดตามเรือเรียลไทม์',
		BaseStation:'สถานี',
		Vessel:'เรือ',
		VesselReport:'รายงานการเดินเรือ',
		EventNotification:'การเเจ้งเตือน',
		VesselGroup:'กลุ่มเรือ',
		Zone:'โซน',
		Setting:'ตั้งค่า',
		ShipType:'ประเภทเรือ',
		MID:'MID',
		PositionFixType:'ประเภทการจับสัญญาณ',
		NavigationStatus:'สถานะการนำทาง',
		Dashboard: 'ภาพรวม',
		eCommerce: 'eCommerce',
		Apps: 'Apps',
		Todo: 'Todo',
		Chat: 'Chat',
		Email: 'Email',
		Calendar: 'Calendar',
		Shop: 'Shop',
		Cart: 'Cart',
    	WishList: 'Wish List',
		Checkout: 'Checkout',
		UIElements: 'UI Elements',
		DataList: 'Data List',
		ListView: 'List View',
		ThumbView: 'Thumb View',
		Grid: 'Grid',
		Vuesax: 'Vuesax',
		Tailwind: 'Tailwind',
		Colors: 'Colors',
		Card: 'Card',
		Basic: 'Basic',
		Statistics: 'Statistics',
		Analytics: 'Analytics',
		CardActions: 'Card Actions',
		Table: 'Table',
		Components: 'Components',
		Alert: 'แจ้งเตือน',
		Avatar: 'Avatar',
		Badge: 'Badge',
		Breadcrumb: 'Breadcrumb',
		Button: 'Button',
		Chip: 'Chip',
		Collapse: 'Collapse',
		Dialogs: 'Dialogs',
		Divider: 'Divider',
		DropDown: 'DropDown',
		List: 'List',
		Loading: 'Loading',
		Navbar: 'Navbar',
		Notifications: 'Notifications',
		Pagination: 'Pagination',
		Popup: 'Popup',
		Progress: 'Progress',
		Sidebar: 'Sidebar',
		Slider: 'Slider',
		Tabs: 'Tabs',
		Tooltip: 'Tooltip',
		Upload: 'Upload',
		Forms: 'Forms',
		FormElements: 'Form Elements',
		Select: 'Select',
		Switch: 'Switch',
		Checkbox: 'Checkbox',
		Radio: 'Radio',
		Input: 'Input',
		NumberInput: 'Number Input',
		Textarea: 'Textarea',
		FormLayouts: 'Form Layouts',
		FormWizard: 'Form Wizard',
		FormValidation: 'Form Validation',
		Pages: 'Pages',
		Authentication: 'Authentication',
		Login: 'Login',
		Register: 'Register',
		ForgotPassword: 'Forgot Password',
		ResetPassword: 'Reset Password',
		LockScreen: 'Lock Screen',
		ComingSoon: 'Coming Soon',
		Error: 'Error',
		404: '404',
		500: '500',
		NotAuthorized: 'Not Authorized',
		Maintenance: 'Maintenance',
		Profile: 'Profile',
		Invoice: 'Invoice',
		FAQ: 'FAQ',
		Search: 'Search',
		KnowledgeBase: 'Knowledge Base',
		ChartsAndMaps: 'Charts & Maps',
		Charts: 'Charts',
		ApexCharts: 'Apex Charts',
		chartjs: 'chartjs',
		echarts: 'echarts',
		chartist: 'chartist',
		GoogleMap: 'Google Map',
		Extensions: 'Extensions',
		QuillEditor: 'Quill Editor',
		DragAndDrop: 'Drag & Drop',
		Datepicker: 'Datepicker',
		AccessControl: 'Access Control',
		EditorView: 'Editor View',
		AdminView: 'Admin View',
		I18n: 'I18n',
		Carousel: 'Carousel',
		Clipboard: 'Clipboard',
		ContextMenu: 'Context Menu',
		Others: 'Others',
		MenuLevels: 'Menu Levels',
		MenuLevel2p1: 'Menu Level 2.1',
		MenuLevel2p2: 'Menu Level 2.2',
		MenuLevel3p1: 'Menu Level 3.1',
		MenuLevel3p2: 'Menu Level 3.2',
		DisabledMenu: 'Disabled Menu',
		Support: 'Support',
		Documentation: 'Documentation',
		RaiseSupport: 'Raise Support',
		demoTitle: 'Card Title',
		demoText: 'Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.',

		FunctionUnavailableNow: 'ฟังก์ชันยังไม่เปิดใช้งาน',
		PleaseSelectInList: 'ต้องเลือกรายการในลิสต์ก่อน',

		EmailIsAlreadyUsed: 'อีเมล์นี้ได้ถูกใช้ไปแล้ว',
		RegisterDonePleaseVerifyEmail: 'สมัครสมาชิกสำเร็จ กรุณายืนยันอีเมล์ของคุณ',
		PasswordResetUrlSent: 'ลิงค์สำหรับรีเซ็ตรหัสผ่านได้ถูกส่งไปที่อีเมล์ของท่านแล้ว',
		Home: 'หน้าหลัก',
		
		Topics: 'บทเรียน',
		Scoreboard: 'ตารางคะแนน',

		Lesson1: 'บทที่ 1',
		Lesson1Unit1: 'รายชื่อสินค้า กิจการ และบริการ',
		Lesson1Unit2: 'อัตราค่าธรรมเนียม',
		Lesson1Unit3: 'รายชื่อเอกสารและฟอร์มที่ใช้ในการปฏิบัติงาน',
		Lesson2: 'บทที่ 2',
		Lesson2Unit1: 'รายชื่อหน่วยงานในกรมสรรพสามิต',
		Lesson2Unit2: 'ตำแหน่ง',
		Lesson3: 'บทที่ 3',
		Lesson3Unit1: 'คำศัพท์ที่เกี่ยวกับกรมสรรพสามิต',
		Lesson4: 'บทที่ 4',
		Lesson5: 'บทที่ 5',
		Lesson6: 'บทที่ 6',
		Lesson6Unit1: '6.1 หน่วยที่ 1 ',
		Lesson6Unit1Chapter1: 'ส่วนที่ 1',
		Lesson6Unit1Chapter2: 'ส่วนที่ 2',
		Lesson6Unit1Quiz: 'แบบทดสอบ',
		Lesson7: 'บทที่ 7',
		Lesson7Unit1: 'งานจัดเก็บภาษี',
		Lesson7Unit1Chapter1: 'การจดทะเบียนสรรพสามิต',
		Lesson7Unit1Chapter2: 'การขอใบอนุญาต',
		Lesson7Unit1Chapter3: 'การรับชำระภาษี',
		Lesson7Unit1Chapter4: 'การออกตรวจภาษี',
		Lesson7Unit2: 'งานปราบปราม',
		Lesson7Unit2Chapter1: 'การออกตรวจสถานที่',
		Lesson7Unit2Chapter2: 'การออกตรวจที่สนามบิน',
		Lesson7Unit3: 'การคำนวณภาษี',
		Lesson7Unit4: 'ประโยคที่ควรรู้ในการปฏิบัติงาน',
		Lesson8: 'บทที่ 8',
		Lesson8Unit1: 'แกรมมา',
		Lesson8Unit2: 'คำศัพท์',
		Lesson8Unit3: 'การอ่านคำความเข้าใจ',
		Lesson8Unit4: 'การสนทนาและบทสนทนา',
		Lesson8Unit5: 'ฝึกแบบทดสอบ',
		Lesson8Unit6: 'ข้อสอบ',
		Lesson9: 'บทที่ 9'

	}
}
